// fun fact: TypeScript does not handle the key name typing and autocomplete well when this module is a JSON file
// additionally, JSON doesn't allow comments, which we need here from time to time
import clients from 'i18n/en/clients'
import gettingStarted from 'i18n/en/getting_started'
import layouts from 'i18n/en/layouts'
import navigation from 'i18n/en/navigation'
import rbacSettings from 'i18n/en/rbac_settings'
import scenarios from 'i18n/en/scenarios'
import service from 'i18n/en/service'
import statusChecks from 'i18n/en/status_checks'
import utils from 'i18n/en/utils'

/**
 * Consolidates all EN text string files
 */
export default {
  ...clients,
  ...gettingStarted,
  ...layouts,
  ...navigation,
  ...rbacSettings,
  ...scenarios,
  ...service,
  ...statusChecks,
  ...utils
}
